/*
  iOS の <button> 押下フィードバック補正

  anok-base.css はタップハイライト (-webkit-tap-highlight-color) を無効化し、
  代替として a / button:active { opacity: 0.6 } を当てている。
  iOS 17 系までの WebKit は <button> に :active を適用しないため、この 1 行が
  無いとフィルタ・ページャ・数量 +/-・送信ボタン等が押下時に無反応になる。
  document に touchstart リスナが 1 つあると <button> にも :active が効くように
  なる。スクロール性能を落とさないよう passive で登録する (passive でも効くことを
  iOS 17.4 Simulator で実測確認済み)。

  iOS 26 系では WebKit 側で解消済み。17 系以前の利用が無くなれば削除してよい。
*/
document.addEventListener('touchstart', function () {}, { passive: true });
